import { BasketballTeam } from '@hefe/models';
import {
  BasketballTeamsSlice,
  BasketballTeamTransferPlayersRequest,
  ModalsSlice,
} from '@hefe/store';
import { Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface TransferPlayersFormProps {
  team: BasketballTeam;
  selectedPlayerIds: number[];
}

export default function TransferPlayersForm(props: TransferPlayersFormProps) {
  const dispatch = useAppDispatch();

  const teams = useSelector(BasketballTeamsSlice.basketballTeamsSelector).map(
    (team) => {
      return {
        value: team.id,
        label: team.name,
      };
    }
  );

  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;

    const submitValues: BasketballTeamTransferPlayersRequest = {
      team_id_from: props.team.id,
      team_id_to: values.team_id,
      player_ids: props.selectedPlayerIds,
    };

    dispatch(setLoading(true));

    dispatch(
      BasketballTeamsSlice.transferPlayersFromBasketballTeam(submitValues)
    )
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical">
      <Typography.Text>
        {t('information_texts.transfer_players')}
      </Typography.Text>
      <CustomForm
        key={`transfer-players-form-${props.team.id}`}
        formId={`transfer-players-form-${props.team.id}`}
        fields={[
          {
            name: 'team_id',
            label: t('team'),
            type: 'select',
            placeholder: t('select'),
            selectOptions: teams,
            rules: [
              {
                required: true,
                type: 'integer',
                message: t('form_errors.name'),
              },
            ],
          },
        ]}
        onSubmit={onSubmit}
      />
    </Space>
  );
}
